module.exports = __webpack_public_path__ + "static/media/empty-cart.d5889100.png";